module.exports = __webpack_public_path__ + "img/elin2024xmas310x588.d10ed0d3.png";